import React from "react"
import MySelectFormField from "@common-components/fields/MySelectFormField"
import MySelectCreatableFormField from "@common-components/fields/MySelectCreatableFormField"
import MyAlert from "@common-utils/MyAlert"
import { CONST_PERSONNEL_NDF_DETAILS_CATEGORIE_REPAS_MIDI } from "@common-constants/*"

export const NdfGroupedMealSection = ({ helpers, validationSchema, index }: any) => {
     if (helpers.values.childs[index].categorie !== CONST_PERSONNEL_NDF_DETAILS_CATEGORIE_REPAS_MIDI) return null

     return (
          <>
               <MySelectFormField
                    formikProps={helpers}
                    validationSchema={validationSchema}
                    label={<div className={"required"}>Type de repas</div>}
                    name={`childs[${index}].repasSeulOuEnGroupe`}
                    options={[
                         { value: "REPAS_MIDI_SEUL", label: "Repas seul" },
                         { value: "REPAS_MIDI_EN_GROUPE", label: "Repas en groupe" },
                    ]}
                    placeholder={"Choisissez si seul ou en groupe"}
                    classNameLabel={"col-lg-4"}
                    classNameField={"col-lg-8"}
                    classNameLayout={"mb-4"}
               />

               {helpers.values.childs[index].repasSeulOuEnGroupe === "REPAS_MIDI_EN_GROUPE" && (
                    <div className="">
                         <div className="row d-flex justify-content-lg-end">
                              <div className={"mb-2 col-lg-8 px-lg-3"}>
                                   <MyAlert type={"primary"}>Saisissez Nom, Prénom et Société (si client).</MyAlert>
                              </div>
                         </div>
                         <MySelectCreatableFormField
                              formikProps={helpers}
                              validationSchema={validationSchema}
                              name={`childs[${index}].invites`}
                              placeholder={"Saisissez les invités"}
                              classNameLabel={"col-lg-4"}
                              classNameField={"col-lg-8"}
                              classNameLayout={"mb-4"}
                         />
                    </div>
               )}
          </>
     )
}
